import { useQuery } from "@tanstack/react-query";
import queryFactory from "./queryFactory";

export default (categoryId: string | undefined) => useQuery(queryFactory.category(categoryId));
